import React from 'react';

const Footer: React.FC = () => {
    return (
        <footer className="bg-gray-800 text-white py-12">
            <div className="container mx-auto px-4">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
                    <div>
                        <h3 className="text-xl font-bold mb-4">Drive Today Auto</h3>
                        <p className="text-gray-400 mb-4">Your trusted partner for premium vehicles and exceptional service.</p>
                        <div className="flex space-x-4">
                            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition" aria-label="Facebook">
                                <i className="fab fa-facebook-f text-xl"></i>
                            </a>
                            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition" aria-label="Twitter">
                                <i className="fab fa-twitter text-xl"></i>
                            </a>
                            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition" aria-label="Instagram">
                                <i className="fab fa-instagram text-xl"></i>
                            </a>
                            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition" aria-label="LinkedIn">
                                <i className="fab fa-linkedin-in text-xl"></i>
                            </a>
                        </div>
                    </div>
                    
                    <div>
                        <h3 className="text-xl font-bold mb-4">Quick Links</h3>
                        <ul className="space-y-2">
                            <li><a href="#home" className="text-gray-400 hover:text-white transition">Home</a></li>
                            <li><a href="https://drivetodayauto.mycarsonline.com/inventory" className="text-gray-400 hover:text-white transition">Inventory</a></li>
                            <li><a href="#services" className="text-gray-400 hover:text-white transition">Services</a></li>
                            <li><a href="#about" className="text-gray-400 hover:text-white transition">About Us</a></li>
                            <li><a href="#contact" className="text-gray-400 hover:text-white transition">Contact</a></li>
                        </ul>
                    </div>
                    
                    <div>
                        <h3 className="text-xl font-bold mb-4">Services</h3>
                        <ul className="space-y-2">
                            <li><a href="#services" className="text-gray-400 hover:text-white transition">Vehicle Sales</a></li>
                            <li><a href="https://drivetodayauto.mycarsonline.com/apply-online" className="text-gray-400 hover:text-white transition">Financing</a></li>                     
                        </ul>
                    </div>
                    
                    <div>
                        <h3 className="text-xl font-bold mb-4">Newsletter</h3>
                        <p className="text-gray-400 mb-4">Subscribe to get updates on new arrivals and special offers.</p>
                        <form className="flex">
                            <input type="email" placeholder="Your email" className="p-3 rounded-l-md w-full text-gray-800 focus:outline-none" />
                            <button type="submit" className="bg-red-600 hover:bg-red-700 px-4 rounded-r-md transition">
                                <i className="fas fa-paper-plane"></i>
                            </button>
                        </form>
                    </div>
                </div>
                
                <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center">
                    <p className="text-gray-400 mb-4 md:mb-0">© 2025 Drive Today Auto. All rights reserved.</p>
                    <div className="flex space-x-6">
                        <a href="https://drivetodayauto.mycarsonline.com/privacy-policy" className="text-gray-400 hover:text-white transition">Privacy Policy</a>
                        <a href="/terms-of-service" className="text-gray-400 hover:text-white transition">Terms of Service</a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer; 